import React from 'react';
import { ConfigurationSectionType } from '@ydistri/api-sdk';
import { CategoryConfigurationDefinitionGroup } from './SegmentPotentialDefinition';
import CategoryConfigurationGroup from './CategoryConfigurationGroup';
import ConfigurationRedistributionSets from './ConfigurationRedistributionSets/ConfigurationRedistributionSets';
import { isRedistributionSetConfigurationSection } from '../configurationUtils';

interface CategoryConfigurationPaneProps {
  sectionType: ConfigurationSectionType;
  definitionGroups?: CategoryConfigurationDefinitionGroup;
  displayTitle?: boolean;
}

const CategoryConfigurationPane: React.FC<CategoryConfigurationPaneProps> = ({
  sectionType,
  definitionGroups,
  displayTitle,
}) => {
  //filter out fields that go to its own Redistribution sets configuration sections
  const sectionDefinitions = definitionGroups?.[sectionType] ?? [];
  const grouped = Object.groupBy(sectionDefinitions, item => {
    if (isRedistributionSetConfigurationSection(sectionType, item.fieldType)) {
      return 'redistributionSets';
    } else {
      return 'main';
    }
  });

  return (
    <>
      {grouped.main && (
        <CategoryConfigurationGroup
          sectionType={sectionType}
          data={grouped.main}
          displayTitle={displayTitle}
        />
      )}
      {grouped.redistributionSets && (
        <ConfigurationRedistributionSets
          data={grouped.redistributionSets}
          sectionType={sectionType}
        />
      )}
    </>
  );
};

export default CategoryConfigurationPane;
